import * as cart from './cart.js';
import * as colorPicker from './color-picker.js';
import * as contactDialog from './contact-dialog.js';
import * as core from './core.js';
import * as forms from './forms.js';
import * as mobileCategories from './mobile-categories.js';
import * as productGallery from './product-gallery.js';
import * as responsiveTable from './responsive-table.js';
import * as searchAutocomplete from './search-autocomplete.js';
import * as stickyTopInfo from './sticky-top-info.js';

// Preserve full-page redirects used by existing sign-in and checkout handlers.
window.naja.defaultOptions.forceRedirect = true;

const modules = [core, searchAutocomplete, colorPicker, contactDialog, cart, responsiveTable, forms, mobileCategories, productGallery, stickyTopInfo];

export function init(root = document) {
	modules.forEach((module) => module.init(root));
}

document.addEventListener('DOMContentLoaded', () => {
	init(document);
	core.initNaja(init);
});

window.VtcFrontend = {init};
